import { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useLazyGetUserReportListQuery } from "../../services/userReport";
import { showError } from "../../helpers";
import ReportsTopbar from "./reportsTopbar";
import { DateRangeType } from "./types";
import Pagination from "../../components/Panigation";

export default function InactiveUsersReportTable() {
  const navigate = useNavigate();
  const [getData] = useLazyGetUserReportListQuery();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [selectRange, setSelectRange] = useState("default");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const totalPages = Math.max(
    1,
    Math.ceil((totalCount || 0) / (pageSize || 10))
  );
  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };
  const [rows, setRows] = useState<any[]>([]);
  const [dateRange, setDateRange] = useState<DateRangeType | null>(null);
  const [dateRange1, setDateRange2] = useState<DateRangeType | null>(null);

  const fetchList = useCallback(async () => {
    try {
      const params: any = {
        page: page,
        limit: pageSize,
        search: debouncedSearchTerm,
        dateFrom: dateRange ? dayjs(dateRange).toISOString() : "",
        dateTo: dateRange1 ? dayjs(dateRange1).toISOString() : "",
      };
      const response = await getData(params).unwrap();
      const list = response?.data?.data || [];
      console.log("list", list);
      // const pagination = response?.data?.length || 0;
      setRows(list);
      setTotalCount(response?.data?.count);
    } catch (error: unknown) {
      const apiMessage = (error as { data?: { message?: string } })?.data
        ?.message;
      showError(apiMessage || "Failed to fetch Feedbacks");
    }
  }, [page, pageSize, debouncedSearchTerm, dateRange, dateRange1]);

  useEffect(() => {
    fetchList();
  }, [page, pageSize, debouncedSearchTerm, dateRange, dateRange1]);

  useEffect(() => {
    const today = dayjs();

    switch (selectRange) {
      case "1": // Day
        const todayStr = today.format("YYYY-MM-DD");
        setDateRange(todayStr);
        setDateRange2(todayStr);
        break;
      case "2": // Week
        const weekAgo = today.subtract(1, "week").format("YYYY-MM-DD");
        setDateRange(weekAgo);
        setDateRange2(today.format("YYYY-MM-DD"));
        break;
      case "3": // Month
        const monthAgo = today.subtract(1, "month").format("YYYY-MM-DD");
        setDateRange(monthAgo);
        setDateRange2(today.format("YYYY-MM-DD"));
        break;
      default:
        // For 'default' or any other value, clear the dates
        setDateRange(null);
        setDateRange2(null);
    }
  }, [selectRange]);

  return (
    <>
      <ReportsTopbar
        page={page}
        pageSize={pageSize}
        type="UserReport"
        setDateRange={setDateRange}
        setDateRange2={setDateRange2}
        setSelectRange={setSelectRange}
      />
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow hover>
              <TableCell>Name</TableCell>
              <TableCell>Membership account</TableCell>
              <TableCell>date</TableCell>
              <TableCell>App Version</TableCell>
              <TableCell>Device Name</TableCell>
              <TableCell>Last Login</TableCell>
              <TableCell>Inactive Since (Days)</TableCell>
              {/* <TableCell>Status</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow hover>
                <TableCell colSpan={4} align="center">
                  No data found
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row: any) => {
                const date = row?.sessionsDetails?.createdAt
                  ? new Date(row.sessionsDetails.createdAt)
                  : null;

                const inactiveDays = date
                  ? Math.floor(
                      (new Date().getTime() - date.getTime()) /
                        (1000 * 3600 * 24)
                    )
                  : "";
                return (
                  <TableRow hover key={row.id}>
                    <TableCell>
                      <Box
                        component="a"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/manage-users/detail/" + row?._id);
                        }}
                        className="user_block click_action"
                      >
                        <p>
                          <b>{row.fullName}</b>
                          <span>{row.email}</span>
                          <span>{row.phoneNo ? row.phoneNo : row.phone}</span>
                        </p>
                      </Box>
                    </TableCell>
                    <TableCell>{row?.memberAccount}</TableCell>
                    <TableCell>{date?.toLocaleDateString()}</TableCell>
                    <TableCell>{row?.sessionsDetails?.appVersion}</TableCell>
                    <TableCell>{row?.sessionsDetails?.deviceName}</TableCell>
                    <TableCell>{date?.toLocaleDateString() || ""}</TableCell>
                    <TableCell>{inactiveDays?.toString() || ""}</TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        module={rows || []}
        page={page}
        setPage={setPage}
        limit={pageSize}
        setLimit={setPageSize}
        onPageChange={onPageChange}
        totalPages={totalPages}
      />
    </>
  );
}
